import type { Participation, Player, PowerSnapshot, Rank } from './api';

// Build a synthetic Participation[] for the plan Planner mode. Players are
// named "Top #1", "Top #2", … in strength order (Top #1 = strongest).
// The top `flexCount` starters are marked as flex, so they sort ahead of
// everyone under the flex-first strength rule in DSPlan/CSPlan autofill.
export function buildPlannerParticipations(opts: {
  starters: number;
  subs: number;
  flex: number;
}): Participation[] {
  const total = opts.starters + opts.subs;
  const result: Participation[] = [];
  for (let i = 0; i < total; i++) {
    const isStarter = i < opts.starters;
    const isFlex = isStarter && i < opts.flex;
    const label = `Top #${i + 1}`;
    const power = total - i;
    const snapshot: PowerSnapshot = {
      id: -1,
      playerId: -1 - i,
      totalPower: power,
      kills: 0,
      m1Power: power,
      m1Type: 'planes',
      m2Power: 0,
      m2Type: 'rockets',
      m3Power: 0,
      m3Type: 'tanks',
      recordedAt: '',
      recordedBy: null,
    };
    const player: Player = {
      id: -1 - i,
      name: label,
      displayName: label,
      realName: null,
      rank: 'R1' as Rank,
      profession: null,
      neverSub: false,
      active: true,
      deleted: false,
      publicId: null,
      country: null,
      baseLevel: null,
      careerType: null,
      preferredCsSlot: null,
      timezone: null,
      lastSyncAt: null,
      createdAt: '',
      updatedAt: '',
      latestSnapshot: snapshot,
      currentLeave: null,
      activeFlags: [],
    };
    result.push({
      id: -1 - i,
      eventId: -1,
      playerId: -1 - i,
      appliedA: false,
      appliedB: false,
      assignedSlot: 'A',
      assignedRole: isStarter ? 'starter' : 'sub',
      assignedPosition: null,
      flex: isFlex,
      attendanceStatus: null,
      notes: null,
      recordedAt: '',
      attendanceRecordedAt: null,
      swapContactMade: false,
      swapAim15Min: false,
      player,
      metrics: null,
    });
  }
  return result;
}
